import { memo, useCallback } from 'react'
import { IconButton } from '@mui/material'
import { ControlPosition, MapControl } from '@vis.gl/react-google-maps'
import { Box } from '@/components/Layout'
import { MinusIcon, PlusIcon } from '@/assets'
import { zoomControlStyles as styles } from './ZoomControl.style'
import { ZoomControlProps } from './ZoomControl.types'
import { MAP_CONFIG } from '../Map.data'

function ZoomControl({ zoom, onZoomChange }: ZoomControlProps) {
  const onZoomIn = useCallback(() => {
    onZoomChange(zoom + 1)
  }, [onZoomChange, zoom])

  const onZoomOut = useCallback(() => {
    onZoomChange(zoom - 1)
  }, [onZoomChange, zoom])

  return (
    <MapControl position={ControlPosition.RIGHT_TOP}>
      <Box sx={styles.wrapper}>
        <Box sx={styles.buttonWrapper}>
          <IconButton sx={styles.button} onClick={onZoomIn} disabled={zoom === MAP_CONFIG.maxZoom}>
            <PlusIcon />
          </IconButton>
        </Box>
        <Box sx={styles.buttonWrapper}>
          <IconButton sx={styles.button} onClick={onZoomOut} disabled={zoom === MAP_CONFIG.minZoom}>
            <MinusIcon />
          </IconButton>
        </Box>
      </Box>
    </MapControl>
  )
}

export default memo(ZoomControl)
